import React, { useState } from "react"

import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'


export const DialogMessage = ({ title, message }) => {
    
    const [open, setOpen] = useState(true);

    const handleClose = () => {
        setOpen(false)
    }
  
    return (
        <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">{ title }</DialogTitle>
            
            <DialogContent>{ message }</DialogContent>
            
            <DialogActions>
                <Button onClick={handleClose} autoFocus>
                    Close
                </Button>
            </DialogActions>

        </Dialog>
)
  }
  
  export default DialogMessage
  